import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dBifunctor from "../Data.Bifunctor/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList from "../Data.List/index.js";
import * as Data$dMap from "../Data.Map/index.js";
import * as Data$dMap$dExtra from "../Data.Map.Extra/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId from "../Restaumatic.Menu.V2.Types.ParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric from "../Restaumatic.Menu.V2.Types.Parametric.Parametric/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $ParametricEvaluationError = (tag, _1, _2) => ({tag, _1, _2});
const intercalate = /* #__PURE__ */ Data$dArray.intercalate1(Data$dMonoid.monoidString);
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dList.toUnfoldable(Data$dUnfoldable.unfoldableArray);
  return x => $0(Data$dMap$dInternal.keys(x));
})();
const fold = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Data$dSet.monoidSet(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId))(Data$dFoldable.identity))();
const all = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap((() => {
  const semigroupConj1 = {append: v => v1 => v && v1};
  return {mempty: true, Semigroup0: () => semigroupConj1};
})()))();
const eq = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.eqParameterId)(Data$dEq.eqUnit).eq)();
const unions = /* #__PURE__ */ Data$dSet.unions(Data$dSet.foldableSet)(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId);
const toUnfoldable1 = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(Data$dMap$dInternal.stepUnfoldr);
  return x => $0(Data$dMap$dInternal.$MapIter("IterNode", x, Data$dMap$dInternal.IterLeaf));
})();
const ordMap = /* #__PURE__ */ Data$dMap$dInternal.ordMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.ordParameterChoiceId);
const fromFoldable = /* #__PURE__ */ Data$dMap$dInternal.fromFoldable(ordMap)(Data$dFoldable.foldableArray);
const fromFoldable1 = /* #__PURE__ */ Data$dMap$dInternal.fromFoldable(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Data$dFoldable.foldableArray);
const member = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = false;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId.compare(k)(v._3);
        if (v1.tag === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1.tag === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1.tag === "EQ") {
          go$c = false;
          go$r = true;
          continue;
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const partitionWithKey = /* #__PURE__ */ Data$dMap$dExtra.partitionWithKey(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId);
const isSubmap = /* #__PURE__ */ Data$dMap$dInternal.isSubmap(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.eqParameterChoiceId);
const identity = x => x;
const MissingParameters = value0 => value1 => $ParametricEvaluationError("MissingParameters", value0, value1);
const MissingValue = /* #__PURE__ */ $ParametricEvaluationError("MissingValue");
const variantValue = Data$dMap$dInternal.singleton;
const variant = values => Data$dMap$dInternal.$$$Map("Node", 1, 1, values, true, Data$dMap$dInternal.Leaf, Data$dMap$dInternal.Leaf);
const valueParams = Data$dMap.keys;
const singleValue = value => ({values: Data$dMap$dInternal.$$$Map("Node", 1, 1, Data$dMap$dInternal.Leaf, value, Data$dMap$dInternal.Leaf, Data$dMap$dInternal.Leaf)});
const showParametricEvaluationError = {
  show: v => {
    if (v.tag === "MissingParameters") {
      return "missing parameter ids: " + intercalate(", ")(Data$dFunctor.arrayMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.showParameterId.show)(toUnfoldable(v._1)));
    }
    if (v.tag === "MissingValue") { return "missing value"; }
    $runtime.fail();
  }
};
const prop_parameterValuesNum = paramValues => {
  const expectedKeys = fold(Data$dFunctor.arrayMap(Data$dMap.keys)(toUnfoldable(paramValues)));
  return all(k => eq(Data$dMap.keys(k))(expectedKeys))(toUnfoldable(paramValues));
};
const parametricParams = /* #__PURE__ */ (() => {
  const $0 = Data$dSet.map(Data$dSet.ordSet(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId))(x => Data$dMap.keys(x));
  return x => unions($0(Data$dMap.keys(x.values)));
})();
const prop_parametricNum = parametric => all(eq(parametricParams(parametric)))(Data$dFunctor.arrayMap(x => Data$dMap.keys(x))(toUnfoldable(Data$dMap.keys(parametric.values))));
const parameters = v => unions(Data$dSet.map(Data$dSet.ordSet(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId))(x => Data$dMap.keys(x))(Data$dMap.keys(v.values)));
const onlyInternalParameters = /* #__PURE__ */ Data$dSet.mapMaybe(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.ordInternalParameterId)(v => {
  if (v.tag === "InternalParameter") { return Data$dMaybe.$Maybe("Just", v._1); }
  if (v.tag === "CustomParameter") { return Data$dMaybe.Nothing; }
  $runtime.fail();
});
const onlyCustomParameters = /* #__PURE__ */ Data$dSet.mapMaybe(Data$dOrd.ordString)(v => {
  if (v.tag === "CustomParameter") { return Data$dMaybe.$Maybe("Just", v._1); }
  if (v.tag === "InternalParameter") { return Data$dMaybe.Nothing; }
  $runtime.fail();
});
const onlyCustomParameterValues = /* #__PURE__ */ (() => {
  const $0 = Data$dMap$dInternal.fromFoldable(Data$dOrd.ordString)(Data$dFoldable.foldableArray);
  const $1 = Data$dArray.mapMaybe(v => {
    if (v._1.tag === "CustomParameter") {
      if (v._2.tag === "CustomParameterChoice") { return Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(v._1._1, v._2._1)); }
      return Data$dMaybe.Nothing;
    }
    return Data$dMaybe.Nothing;
  });
  return x => $0($1(toUnfoldable1(x)));
})();
const noValue = {values: Data$dMap$dInternal.Leaf};
const never = noValue;
const mapAssign = Data$dMap$dInternal.singleton;
const make = entries => ({values: fromFoldable(Data$dFunctor.arrayMap(Data$dBifunctor.bifunctorTuple.bimap(Unsafe$dCoerce.unsafeCoerce)(Data$dBifunctor.identity))(entries))});
const isPossible = dict => dict.isPossible;
const internalAssign = param => value => Data$dMap$dInternal.$$$Map(
  "Node",
  1,
  1,
  Restaumatic$dMenu$dV2$dTypes$dParameterId.$ParameterId("InternalParameter", param),
  Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.$ParameterChoiceId("InternalParameterChoice", value),
  Data$dMap$dInternal.Leaf,
  Data$dMap$dInternal.Leaf
);
const fromInternalParameterValues = /* #__PURE__ */ (() => {
  const $0 = Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(
    Restaumatic$dMenu$dV2$dTypes$dParameterId.$ParameterId("InternalParameter", v._1),
    Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.$ParameterChoiceId("InternalParameterChoice", v._2)
  ));
  return x => fromFoldable1($0(toUnfoldable1(x)));
})();
const fromCustomParameterValues = /* #__PURE__ */ (() => {
  const $0 = Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(
    Restaumatic$dMenu$dV2$dTypes$dParameterId.$ParameterId("CustomParameter", v._1),
    Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.$ParameterChoiceId("CustomParameterChoice", v._2)
  ));
  return x => fromFoldable1($0(toUnfoldable1(x)));
})();
const eqParametricEvaluationError = dictEq => {
  const eq2 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.eqParametric(dictEq).eq;
  return {
    eq: x => y => {
      if (x.tag === "MissingParameters") {
        if (y.tag === "MissingParameters") { return eq(x._1)(y._1) && eq2(x._2)(y._2); }
        return false;
      }
      if (x.tag === "MissingValue") { return y.tag === "MissingValue"; }
      return false;
    }
  };
};
const eq1 = /* #__PURE__ */ (() => {
  const $0 = eqParametricEvaluationError(Data$dEq.eqBoolean);
  return x => y => {
    if (x.tag === "Left") {
      if (y.tag === "Left") { return $0.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "Right") {
      if (y.tag === "Right") { return x._1 === y._1; }
      return false;
    }
    return false;
  };
})();
const customAssign = param => value => Data$dMap$dInternal.$$$Map(
  "Node",
  1,
  1,
  Restaumatic$dMenu$dV2$dTypes$dParameterId.$ParameterId("CustomParameter", param),
  Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.$ParameterChoiceId("CustomParameterChoice", value),
  Data$dMap$dInternal.Leaf,
  Data$dMap$dInternal.Leaf
);
const asInternalParameterChoiceId = v => {
  if (v.tag === "InternalParameterChoice") { return Data$dMaybe.$Maybe("Just", v._1); }
  return Data$dMaybe.Nothing;
};
const asCustomParameterChoiceId = v => {
  if (v.tag === "CustomParameterChoice") { return Data$dMaybe.$Maybe("Just", v._1); }
  return Data$dMaybe.Nothing;
};
const applyParameters = v => providedParamValues => {
  const providedParams = Data$dMap.keys(providedParamValues);
  return {
    missingParameters: Data$dMap$dInternal.unsafeDifference(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId.compare, parametricParams(v), providedParams),
    remainingOptions: {
      values: fromFoldable(Data$dArray.mapMaybe(v1 => {
        const usedVariantParams = partitionWithKey(paramId => _paramValue => member(paramId)(providedParams))(v1._1);
        if (isSubmap(usedVariantParams.yes)(providedParamValues)) { return Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(usedVariantParams.no, v1._2)); }
        return Data$dMaybe.Nothing;
      })(toUnfoldable1(v.values)))
    }
  };
};
const evaluateAllValues = dictOrd => {
  const fromFoldable3 = Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(dictOrd)(a)()(m))(Data$dMap$dInternal.Leaf);
  return parametric => valuesToApply => fromFoldable3(Data$dFunctor.arrayMap(Data$dTuple.snd)(toUnfoldable1(applyParameters(parametric)(valuesToApply).remainingOptions.values)));
};
const evaluateParametric = parametric => valuesToApply => {
  const v = applyParameters(parametric)(valuesToApply);
  const v1 = toUnfoldable1(v.remainingOptions.values);
  if (v1.length === 0) {
    if (v.missingParameters.tag === "Leaf") { return Data$dEither.$Either("Left", MissingValue); }
    return Data$dEither.$Either("Left", $ParametricEvaluationError("MissingParameters", v.missingParameters, v.remainingOptions));
  }
  if (v1.length === 1) {
    if (v.missingParameters.tag === "Leaf") { return Data$dEither.$Either("Right", v1[0]._2); }
    return Data$dEither.$Either("Left", $ParametricEvaluationError("MissingParameters", v.missingParameters, v.remainingOptions));
  }
  return Data$dEither.$Either("Left", $ParametricEvaluationError("MissingParameters", v.missingParameters, v.remainingOptions));
};
const isMemberOfParametricSet = parametric => valuesToApply => eq1(evaluateParametric(parametric)(valuesToApply))(Data$dEither.$Either("Right", true));
const isParametricPossible = {
  isPossible: parametric => values$p => {
    const v = evaluateParametric(parametric)(values$p);
    if (v.tag === "Right") { return true; }
    if (v.tag === "Left") {
      if (v._1.tag === "MissingValue") { return false; }
      if (v._1.tag === "MissingParameters") { return !(v._1._2.values.tag === "Leaf"); }
      $runtime.fail();
    }
    $runtime.fail();
  }
};
const isParametricPossibleBoole = {
  isPossible: parametric => values$p => {
    const v = evaluateParametric(parametric)(values$p);
    if (v.tag === "Right") { return v._1; }
    if (v.tag === "Left") {
      if (v._1.tag === "MissingValue") { return false; }
      if (v._1.tag === "MissingParameters") { return !(Data$dMap$dInternal.filterWithKey(ordMap)(v$1 => identity)(v._1._2.values).tag === "Leaf"); }
      $runtime.fail();
    }
    $runtime.fail();
  }
};
const any = pred => v => {
  const go = v$1 => {
    if (v$1.tag === "Leaf") { return false; }
    if (v$1.tag === "Node") { return go(v$1._5) || pred(v$1._4) || go(v$1._6); }
    $runtime.fail();
  };
  return go(v.values);
};
const always = {values: /* #__PURE__ */ Data$dMap$dInternal.$$$Map("Node", 1, 1, Data$dMap$dInternal.Leaf, true, Data$dMap$dInternal.Leaf, Data$dMap$dInternal.Leaf)};
export {
  $ParametricEvaluationError,
  MissingParameters,
  MissingValue,
  all,
  always,
  any,
  applyParameters,
  asCustomParameterChoiceId,
  asInternalParameterChoiceId,
  customAssign,
  eq,
  eq1,
  eqParametricEvaluationError,
  evaluateAllValues,
  evaluateParametric,
  fold,
  fromCustomParameterValues,
  fromFoldable,
  fromFoldable1,
  fromInternalParameterValues,
  identity,
  intercalate,
  internalAssign,
  isMemberOfParametricSet,
  isParametricPossible,
  isParametricPossibleBoole,
  isPossible,
  isSubmap,
  make,
  mapAssign,
  member,
  never,
  noValue,
  onlyCustomParameterValues,
  onlyCustomParameters,
  onlyInternalParameters,
  ordMap,
  parameters,
  parametricParams,
  partitionWithKey,
  prop_parameterValuesNum,
  prop_parametricNum,
  showParametricEvaluationError,
  singleValue,
  toUnfoldable,
  toUnfoldable1,
  unions,
  valueParams,
  variant,
  variantValue
};
